export default __webpack_public_path__ + "static/concept-cfc9faeae5a8165b4635a55b0770c037.mp4";